module.exports = __webpack_public_path__ + "img/MemeETC (12).50a81f7c.jpeg";